import React from 'react'

interface IconProps {
  size?: number
  color?: string
  strokeWidth?: number
  className?: string
  onClick?: React.MouseEventHandler<SVGSVGElement>
  tooltip?: string
  style?: React.CSSProperties
}

export const XmarkIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  className = '',
  onClick,
  tooltip,
  style,
}) => {
  return (
    <svg
      style={{ cursor: 'pointer', ...style }}
      onClick={onClick}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {tooltip && <title>{tooltip}</title>}
      <path d="M18 6L6 18" />
      <path d="M6 6L18 18" />
    </svg>
  )
}

export default XmarkIcon
